var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7999 21.1882L22.4285 12.5595C20.9769 11.9531 19.6586 11.0676 18.5482 9.95316C17.4332 8.84255 16.5473 7.52375 15.9407 6.07166L7.31203 14.7003C6.63886 15.3735 6.30169 15.7107 6.01236 16.0817C5.67098 16.5197 5.378 16.9934 5.13853 17.4945C4.93669 17.9192 4.78619 18.3718 4.48519 19.2748L2.89619 24.0383C2.82306 24.2564 2.81221 24.4906 2.86486 24.7145C2.91751 24.9385 3.03158 25.1433 3.19424 25.3059C3.3569 25.4686 3.56171 25.5827 3.78564 25.6353C4.00958 25.688 4.24376 25.6771 4.46186 25.604L9.22536 24.015C10.1295 23.714 10.581 23.5635 11.0057 23.3617C11.5089 23.1221 11.9799 22.8308 12.4185 22.4878C12.7895 22.1985 13.1267 21.8613 13.7999 21.1882ZM24.8225 10.1655C25.6829 9.30515 26.1662 8.13828 26.1662 6.92158C26.1662 5.70487 25.6829 4.538 24.8225 3.67766C23.9622 2.81732 22.7953 2.33398 21.5786 2.33398C20.3619 2.33398 19.195 2.81732 18.3347 3.67766L17.2999 4.71249L17.3442 4.84199C17.854 6.30123 18.6885 7.62565 19.7849 8.71533C20.9071 9.84444 22.2779 10.6954 23.7877 11.2003L24.8225 10.1655Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.d8bda01ce403caae7c33fab5f4aff5a7.svg";
export { ForwardRef as ReactComponent };